var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "images_12_1_",
    "data-name": "images (12) (1)",
    x: 13,
    y: 5,
    width: 34,
    height: 50,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAyCAYAAAA5kQlZAAACzklEQVRYhc2ZO2gUURSGvyyxUIQgURBj0CIhKMHCt0ZsRLQTo/ERxEasRBsbEQSRaCUR1FIRFVQstBI0QbQQDSYGUSMk0SLiEx8giJGA/HKWOzAZZ7OPO7uzP1x2dveec765c+eeM3dqJBGjFcBu97kA+AvEdgz9Hv2/xv2WAWqBMaAfuAE8/d+LFG61ki6q/LIY08KxwyMyA3gCLMlx5knrFbAK+I0btkD3KghhanUxCYPsBdZVECKQxdxjx8GlGQGaUwAJYrcYSBMwmhJEoCa7NEtThjCtNJC6KgCZZSCfqwDkvc2ReuBbyiD1NiLfgfspQvQAP4LbdxkwkBKIxR4MFrRnwKkUILoMInsUSXrdFUh4gc6EY0dBrLVLGiwjwICkbdG4ueoR0yZgH9CRZ3h/AldD3yeAj8BMlza2uONrrt2J9RIzIg2STkh6KOldAWf4MsZHq6RzkvolTbh+Y5IeSToraVHUJupgp6RfRQ71cMTHzQLtDuUCMYhSNBry0Vek/dEoSGNpDFmNOB9dJdq3hUFueYD0Smr2sB8yBlvQZgNbS1uPsvoCdHrYLwaWW5m/wcOJqdE1H200kAZPJ+s97U3NmQI6VUQZtwr6yJ6F+jx9jGYSqEXeAHc9ffQayFfgtoeTucB1D/uhbC2U4IJ2skT7teVY4h8XaXskV9LrqGDSO5ivMJon6bikBy51FwsSFFc9ksYjfT9LuiCppZjCaDOwH2jPM9myz65TTOT5bsvDCqhh4E9sz5iz2SXphcelKanVRrjOAwfy3W/lUHiJP50WBCGQNcDhtCDCIN1pQuBAbFavrgaQtrQhcCBzEvCRCMh4tYA89/TxNikQ25L45OHDp5aZBILbpyhF9sB9OQmQcF4oZStiexJ5JloG1LkEVqiOJQURV49Ml3QlD8gHSZ1JQkxVj1ju2eFeHC10rzJeux3ASwnc8pMF/AO0SRMcnlewmAAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.cf83c19b2bb632dbd523789514f65237.svg";
export { ForwardRef as ReactComponent };